module.exports = __webpack_public_path__ + "static/media/google-play.e760ce49.png";